import React from 'react';
import { FaTachometerAlt, FaComments, FaChartLine, FaChartPie } from 'react-icons/fa';
import Button from './UI/Button';
import { getAuth, signOut } from 'firebase/auth';
import styles from './LeftNavBar.module.css';
import { Link } from 'react-router-dom';

const LeftNavBar = ({ activeSegment }) => {

    const handleSignout = () => {
        signOut(getAuth())
            .then(() => { })
            .catch((error) => { console.error('Sign out error', error); });
    }

    return (
        <nav className={styles.nav}>
            <div className={styles.nav_wrapper}>
                <img src={require('../assets/images/logo-white.png')} alt="logo" className={styles.logo} />
                <ul className={styles.ul}>
                    <li className={`${styles.nav_item} ${activeSegment === 'dashboard' ? styles.nav_item_active : ''}`}>
                        <Link to={"/dashboard"} className={styles.a}>
                            <FaTachometerAlt className={styles.icon} /> Dashboard
                        </Link>
                    </li>
                    <li className={`${styles.nav_item} ${activeSegment === 'chats' ? styles.nav_item_active : ''}`}>
                        <Link to={"/chats"} className={styles.a}>
                            <FaComments className={styles.icon} /> Chats
                        </Link>
                    </li>
                    <li className={`${styles.nav_item} ${activeSegment === 'site_analytics' ? styles.nav_item_active : ''}`}>
                        <span className={styles.a}>
                            <FaChartLine className={styles.icon} /> Site Analytics
                            <span className={styles.span}>BETA</span>
                        </span>
                    </li>
                    <li className={`${styles.nav_item} ${activeSegment === 'ppc_analytics' ? styles.nav_item_active : ''}`}>
                        <span className={styles.a}>
                            <FaChartPie className={styles.icon} /> PPC Analytics
                            <span className={styles.span}>BETA</span>
                        </span>
                    </li>
                </ul>
                <Button text="Sign Out" onClick={handleSignout} wrapperClassName={styles.signout} />
            </div>
        </nav>
    );
}

export default LeftNavBar;